<span [ngStyle]="{'font-size': fontSize}">
  <fa-layers [fixedWidth]="fixedWidth" [attr.title]="title ? title : undefined">
    <fa-icon [icon]="['fas', backgroundIconName]" [class]="backgroundClass"/>
    <fa-layers-text [content]="text ? text.substring(0, 1) : noTextPlaceContent" [class]="textClass" transform="shrink-4"/>
  </fa-layers>
</span>
